<template>
  <div
    class="audio-playlist-player-container"
    :class="{ 'audio-playlist-player-doomyoga': client_name == 'DY' }"
  >
    <b-row>
      <b-col lg="9" class="mx-auto">
        <b-card
          class="card-transparent-background card-media-container-doomyoga mt-1"
          :title="playlist_title"
        >
          <div class="container px-0">
            <b-row>
              <b-col>
                <dataset
                  :ds-data="tracks"
                  :ds-search-in="['title', 'artist', 'album']"
                  :ds-search-as="{ searchTest }"
                >
                  <!-- <div class="row mb-2" :data-page-count="ds.dsPagecount">
                    <div class="col-xl-6 col-md-6">
                      <b-input-group class="input-group-search">
                        <template #prepend>
                          <font-awesome-icon
                            icon="fa-solid fa-magnifying-glass"
                            size="lg"
                          />
                        </template>
                        <dataset-search ds-search-placeholder="Search"
                      /></b-input-group>
                    </div>
                    <div
                      class="
                        col-xl-3 col-md-3
                        px-md-0 px-3
                        addButtonContainerDiv
                      "
                    ></div>
                    <div class="col-xl-3 col-md-3 pr-md-0">
                      <dataset-show
                        :ds-show-entries="5"
                        class="showEntriesSelectContainer float-right"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="row">
                <div class="col-md-12">
                  <div class="row my-2">
                    <div class="col">
                      <h3 class="media-category-title">{{ title }}</h3>
                    </div>
                  </div>
                </div>
              </div> -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table
                          class="
                            table
                            doomYogaCustomerTable
                            doomYogaPlaylistTable
                          "
                        >
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th>Title</th>
                              <th>Duration</th>
                            </tr>
                          </thead>
                          <dataset-item tag="tbody">
                            <template #default="{ row, rowIndex }">
                              <tr @click="play($event, row)">
                                <td scope="row">{{ rowIndex + 1 }}</td>
                                <td>
                                  <img
                                    v-if="row.cover_image == null"
                                    src="@/assets/images/doom-yoga/doomyoga-music.png"
                                  />
                                  <img v-else :src="row.cover_image.full_path" />
                                  <span> {{ row.title }} </span>
                                </td>
                                <td>{{ row.time_duration }}</td>
                              </tr>
                            </template>
                            <template #noDataFound>
                              <tr>
                                <td colspan="4">
                                  <p class="text-center datasetNoFoundP mb-0">
                                    No data found
                                  </p>
                                </td>
                              </tr>
                            </template>
                          </dataset-item>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- <div
                    class="
                      d-flex
                      flex-md-row flex-column
                      justify-content-between
                      align-items-center
                    "
                  >
                    <dataset-info class="mb-2 mb-md-0 datasetInfo" />
                    <dataset-pager />
                  </div> -->
                </dataset>
              </b-col>
            </b-row>
          </div>

          <div class="music-player">
            <!-- the audio player code starts here -->
            <div class="player" id="player">
              <div class="container player-container">
                <div class="player-contents-wrap">
                  <b-row>
                    <b-col lg="3" md="4" class="track-data">
                      <div class="album-art">
                        <img :src="currentSong.cover_image" class="img" />
                      </div>
                      <div class="title">
                        <p class="trackTitle">{{ currentSong.title }}</p>
                        <p class="trackArtist">{{ currentSong.created_by }}</p>
                      </div>
                    </b-col>
                    <b-col lg="7" md="8">
                      <div class="main-controls">
                        <div class="controls">
                          <button
                            class="control-icon shuffle-icon"
                            :class="{ active: isShuffle == true }"
                            @click="shuffleToggle"
                          >
                            <font-awesome-icon icon="fa-solid fa-shuffle" />
                          </button>
                          <button
                            class="control-icon skip-backward"
                            @click="skip('backward')"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-backward-step"
                            />
                          </button>

                          <button
                            class="control-icon play"
                            v-if="!isPlaying"
                            @click="playCurrentSong"
                          >
                            <font-awesome-icon icon="fas fa-play" />
                            
                          </button>
                          <button
                            class="control-icon play"
                            v-else
                            @click="pause"
                          >
                            <font-awesome-icon icon="fas fa-pause" />
                          </button>

                          <button
                            class="control-icon skip-forward"
                            @click="skip('forward')"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-forward-step"
                            />
                          </button>

                          <button class="control-icon repeat" @click="repeat">
                            <img
                              v-if="!onRepeat"
                              class="player-actions-img"
                              src="@/assets/images/doom-yoga/repeat-icon.png"
                              alt="doomyoga Logo"
                            /><img
                              v-else-if="onRepeat && loop.value == '1'"
                              class="player-actions-img"
                              src="@/assets/images/doom-yoga/repeat-once-icon.png"
                              alt="doomyoga Logo"
                            /><img
                              v-else-if="onRepeat && loop.value == 'all'"
                              class="player-actions-img"
                              src="@/assets/images/doom-yoga/repeat-icon-active.png"
                              alt="doomyoga Logo"
                            />
                          </button>
                          <button class="control-icon volume" @click="mute()">
                            <font-awesome-icon
                              icon="fa-solid fa-volume-high"
                              v-if="
                                audioPlayer == null ||
                                audioPlayer.muted == false
                              "
                            />
                            <font-awesome-icon
                              icon="fa-solid fa-volume-mute"
                              v-else-if="
                                audioPlayer != null && audioPlayer.muted == true
                              "
                            />
                          </button>
                        </div>
                      </div>
                      <!-- progress and time-->
                      <div class="seek">
                        <div class="title-and-time">
                          <div class="time">
                            {{ currentPlayedTime }}
                          </div>
                        </div>

                        <div class="progress-container">
                          <div class="progress" id="progress-wrap">
                            <div
                              class="progress-handle"
                              :style="{ left: progressPercentageValue }"
                            ></div>

                            <div
                              class="transparent-seeker-layer"
                              @click="seek"
                            ></div>

                            <div
                              class="bar"
                              :style="{ width: progressPercentageValue }"
                            ></div>
                          </div>
                        </div>
                        <div class="title-and-time">
                          <div class="time">
                            {{ duration }}
                          </div>
                        </div>
                      </div>
                    </b-col>
                    <b-col lg="3"> </b-col>
                  </b-row>
                </div>
              </div>
            </div>
            <!-- the audio player code ends here -->
          </div>

          <audio
            :loop="innerLoop"
            ref="audiofile"
            :src="defaultSong"
            preload
            style="display: none"
            controls
          ></audio>
        </b-card> </b-col
    ></b-row>
  </div>
</template>


<script>
import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce, fieldFilter, findAny } from "vue-dataset/src/helpers";

export default {
  name: "AudioPlaylistPlayer",
  components: {},
  props: ["client_name", "playlist_title", "tracks"],
  data() {
    return {
      defaultSong: "https://www.bensound.com/bensound-music/bensound-hey.mp3",
      isPlaying: false,
      isLoaded: false,
      isCurrentlyPlaying: "",
      onRepeat: false,
      shuffle: false,

      loop: {
        state: false,
        value: 1,
      },

      durationSeconds: 0,
      currentSeconds: 0,
      audioPlayer: undefined,
      previousVolume: 35,
      volume: 100,
      autoPlay: false,
      progressPercentageValue: "0%",

      playlist: {
        currentIndex: 0,

        songs: clone(this.tracks),
      },
      previousPlaylistIndex: 0,
      hasNext: false,
      originalSongArray: [],

      currentSong: {
        id: "",
        title: "",
        created_by: "",
        album: "",
        media: "",
        cover_image: "",
      },

      /** ui control variables*/

      showPlaylist: false,
      isShuffle: false,
    };
  },
  created() {
    this.innerLoop = this.loop.state;
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  mounted() {
    // this.audioPlayer = this.$el.querySelectorAll("audio")[0];
    // this.initPlayer();
    this.initComponent();

  },
  updated() {},
  methods: {
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    // updateData() {
    //   const updatedList = clone(tracks).slice(5, 5);
    //   this.tracks = updatedList;
    // },
    initComponent() {
      console.log();
      this.playlist.currentIndex = 0;
      this.playlist.songs = clone(this.tracks);
      let temp = this;
      // setTimeout(function () {
      console.log(temp.playlist);
      temp.defaultSong = temp.tracks[0].media.full_path;
      temp.audioPlayer = temp.$el.querySelectorAll("audio")[0];
      temp.initPlayer();
      // }, 1000);
    },
    startsWithFilter(value) {
      return (
        value === null ||
        value.toLowerCase().startsWith(this.startsWith.toLowerCase())
      );
    },
    searchTest(value, searchString, rowData) {
      console.log(value);
      console.log(searchString);
      console.log(rowData);
      console.log(searchString === value);
      return searchString === value;
    },
    fieldFilter,

    /** UI control methods
     * these methods are used to control the ui*/

    toggleShowPlaylist() {
      this.showPlaylist = !this.showPlaylist;
    },

    /**Music player methods
     * these methods are used to control the music player*/

    initPlayer() {
      this.audioPlayer.src = this.playlist.songs[0].media.full_path;
      this.setCurrentSong(this.playlist.songs[0]);

      this.audioPlayer.addEventListener("timeupdate", this.updateTimer);
      this.audioPlayer.addEventListener("loadeddata", this.load);
      this.audioPlayer.addEventListener("pause", () => {
        this.isPlaying = false;
      });
      this.audioPlayer.addEventListener("play", () => {
        this.isPlaying = true;
      });

      this.audioPlayer.addEventListener("ended", this.playNextSongInPlaylist);
    },

    play(e, song = {}) {
      if (typeof song === "object") {
        if (this.isLoaded) {
          //check if song exists in playlist

          if (this.currentSong.id === song.id && this.isPlaying) {
            this.pause();
          } else if (this.currentSong.id === song.id && !this.isPlaying) {
            this.playCurrentSong();
          } else if (this.currentSong.id !== song.id) {
            if (!this.containsObjectWithSameId(song, this.playlist.songs)) {
              this.addToPlaylist(song);
            } else {
              console.log("playMethod", "song already in playlist");
            }

            this.setAudio(song.media.full_path);
            this.setCurrentSong(song);
            this.playlist.currentIndex = this.getObjectIndexFromArray(
              song,
              this.playlist.songs
            );
            this.previousPlaylistIndex = this.playlist.currentIndex;
            this.audioPlayer.play();
          }
        } else {
          this.setAudio(song.media.full_path);
          this.audioPlayer.play();
        }

        this.isPlaying = true;
      } else {
        throw new Error("Type Error : Song must be an object");
      }
    },

    playCurrentSong() {
      this.audioPlayer.play();
      this.isPlaying = true;
    },

    stop() {
      this.audioPlayer.currentTime = 0;
    },

    pause() {
      this.audioPlayer.pause();
      this.isPlaying = false;
    },

    repeat() {
      // console.log("repeat", this.loop.state, this.onRepeat, this.loop.value);
      if (!this.loop.state && !this.onRepeat) {
        //firstclick
        this.loop.state = true;
        this.loop.value = 1;
        this.onRepeat = true;
      } else if (this.loop.state && this.onRepeat && this.loop.value === 1) {
        //second click
        this.loop.state = true;
        this.loop.value = "all";
        this.onRepeat = true;
      } else if (
        this.loop.state &&
        this.onRepeat &&
        this.loop.value === "all"
      ) {
        this.loop.state = false;
        this.loop.value = 1;
        this.onRepeat = false;
      }
      // console.log("---- repeat", this.loop.state, this.onRepeat, this.loop.value);
    },

    skip(direction) {
      if (direction === "forward") {
        this.playlist.currentIndex += 1;
      } else if (direction === "backward") {
        this.playlist.currentIndex -= 1;
      }

      /**if the current Index of the playlist is greater or equal to the length of the playlist songs (the index is out of range)
       reset the index to 0. It could also mean that the playlist is at its end. */

      if (this.playlist.currentIndex >= this.playlist.songs.length) {
        this.playlist.currentIndex = 0;
      }

      if (this.playlist.currentIndex < 0) {
        this.playlist.currentIndex = this.playlist.songs.length - 1;
      }

      this.audioPlayer.src =
        this.playlist.songs[this.playlist.currentIndex].media.full_path;
      this.setCurrentSong(this.playlist.songs[this.playlist.currentIndex]);

      //the code below checks if a song is playing so it can go ahead and auto play
      if (this.isPlaying) {
        this.audioPlayer.play();
      }
    },

    mute() {
      //this.muted is a computed variable available down below
      this.audioPlayer.muted = !this.audioPlayer.muted;
    },

    updateTimer() {
      this.currentSeconds = parseInt(this.audioPlayer.currentTime);
      this.progressPercentageValue =
        ((this.currentSeconds / parseInt(this.audioPlayer.duration)) * 100 ||
          0) + "%";
    },

    seek(e) {
      if (this.isLoaded) {
        let el = e.target.getBoundingClientRect();
        let seekPos = (e.clientX - el.left) / el.width;
        let seekPosPercentage = seekPos * 100 + "%";

        /**
         *  calculating the portion of the song based on where the user clicked
         *
         */

        let songPlayTimeAfterSeek = parseInt(
          this.audioPlayer.duration * seekPos
        );

        this.audioPlayer.currentTime = songPlayTimeAfterSeek;

        this.progressPercentageValue = seekPosPercentage;
        console.log(this.progressPercentageValue);
      } else {
        throw new Error("Song Not Loaded");
      }
    },

    addAndPlayNext() {
      let selectedSong = {
        title: "Song Name 3",
        created_by: "Artist Name",
        album: "Album Name",
        media: "./song2.mp3",
        cover_image: "/cover/art/media.jpg",
        isPlaying: false,
      };

      //add the song to the playlist

      //get the index of the song that is currently being played in the player

      //insert the song at that position

      let indexOfCurrentSong = this.playlist.currentIndex;

      this.playlist.songs.splice(indexOfCurrentSong + 1, 0, selectedSong);
    },

    addToPlaylist(song) {
      this.playlist.songs.unshift(song);
    },

    dragSeek(e) {
      let el = e.target.getBoundingClientRect();
    },

    playNextSongInPlaylist() {
      if (this.onRepeat && this.loop.value === 1) {
        this.audioPlayer.play();
      } else {
        if (this.playlist.songs.length > 1) {
          if (this.random) {
            //generate a random number
            let randomNumber = this.generateRandomNumber(
              0,
              this.playlist.songs.length - 1,
              this.previousPlaylistIndex
            );

            //set the current index of the playlist
            this.playlist.currentIndex = randomNumber;

            //set the src of the audio player
            this.audioPlayer.src =
              this.playlist.songs[this.playlist.currentIndex].media.full_path;
            //set the current song
            this.setCurrentSong(
              this.playlist.songs[this.playlist.currentIndex]
            );
            //begin to play
            this.audioPlayer.play();
          } else {
            /**if the current Index of the playlist is equal to the index of the last song played skip that song
             and add 1*/

            if (this.playlist.currentIndex === this.previousPlaylistIndex) {
              //increment the current index of the playlist by 1
              this.playlist.currentIndex += 1;
            }

            /**if the current Index of the playlist is greater or equal to the length of the playlist songs (the index is out of range)
             reset the index to 0. It could also mean that the playlist is at its end. */

            if (this.playlist.currentIndex >= this.playlist.songs.length) {
              if (this.onRepeat && this.loop.value === "all") {
                //if repeat is on then replay from the top
                this.playlist.currentIndex = 0;
              } else {
                return;
              }
            }

            this.audioPlayer.src =
              this.playlist.songs[this.playlist.currentIndex].media.full_path;
            this.setCurrentSong(
              this.playlist.songs[this.playlist.currentIndex]
            );
            this.audioPlayer.play();
            this.playlist.currentIndex++;
          }
        } else {
        }
      }
    },

    shuffleToggle() {
      // console.log("in shuffleToggle", this.isShuffle);
      this.isShuffle = !this.isShuffle;
      if (this.isShuffle) {
        //shuffle the playlist songs and rearrange
        this.playlist.songs = this.shuffleArray(this.playlist.songs);

        //reset the playlist index when changed and rest the previous playlist index
      } else {
        this.playlist.songs = clone(this.tracks);
      }

      this.playlist.currentIndex = this.getObjectIndexFromArray(
        this.currentSong,
        this.playlist.songs
      );
      this.previousPlaylistIndex = this.playlist.currentIndex;
    },

    /** Helper methods
     * these methods are usually used within other methods*/

    formatTime(secs) {
      var minutes = Math.floor(secs / 60) || 0;
      var seconds = Math.floor(secs - minutes * 60) || 0;
      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },

    setAudio(song) {
      this.audioPlayer.src = song;
    },

    load() {
      if (this.audioPlayer.readyState >= 2) {
        this.isLoaded = true;
        this.durationSeconds = parseInt(this.audioPlayer.duration);
      } else {
        throw new Error("Failed to load sound file.");
      }
    },

    playlistHelper() {},

    containsObjectWithSameId(obj, list) {
      let i;
      for (i = 0; i < list.length; i++) {
        if (list[i].id === obj.id) {
          return true;
        }
      }
    },

    getObjectIndexFromArray(obj, list) {
      //this function just returns the index of the item with the id
      let i;
      for (i = 0; i < list.length; i++) {
        if (list[i].id === obj.id) {
          return i;
        }
      }
    },

    setCurrentSong(song) {
      this.currentSong.id = song.id;
      this.currentSong.title = song.title;
      this.currentSong.created_by = song.created_by;
      this.currentSong.album = song.album;
      this.currentSong.media = song.media.full_path;
      this.currentSong.cover_image = song.cover_image.full_path;

      this.previousPlaylistIndex = this.playlist.currentIndex;
    },

    generateRandomNumber(min, max, except) {
      let num = null;
      num = Math.floor(Math.random() * (max - min + 1)) + min;
      return num === except ? this.generateRandomNumber(min, max, except) : num;
    },

    shuffleArray(array) {
      let ctr = array.length;
      let temp;
      let index;

      // While there are elements in the array
      while (ctr > 0) {
        // Pick a random index
        index = Math.floor(Math.random() * ctr);
        // Decrease ctr by 1
        ctr--;
        // And swap the last element with it
        temp = array[ctr];
        array[ctr] = array[index];
        array[index] = temp;
      }
      return array;
    },
  },

  computed: {
    currentPlayedTime() {
      return this.formatTime(this.currentSeconds);
    },
    duration() {
      return this.formatTime(this.durationSeconds);
    },
    progressPercentage() {
      return parseInt((this.currentSeconds / this.durationSeconds) * 100);
    },
    muted() {
      //this returns true or false
      return this.volume / 100 === 0;
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/media_components/AudioPlaylistPlayer.vue